import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import { responsive } from '../ProfilePersonalitySection';
import { MeetingRecordingDocument } from 'types';

interface Props {
	isSummaryAvailable: boolean;
	recordings: MeetingRecordingDocument[];
}

const oneItemResponsive = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 1,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1220 },
		items: 1,
	},
	tablet: {
		breakpoint: { max: 1220, min: 764 },
		items: 1,
	},
	mobile: {
		breakpoint: { max: 764, min: 0 },
		items: 1,
	},
};

const VideoRecordingContainer = ({ isSummaryAvailable, recordings }: Props) => {
	const [showOneItemInCarousel, setShowOneItemInCarousel] = useState<boolean>(false);

	useEffect(() => {
		if (window.innerWidth > 960 && isSummaryAvailable) {
			setShowOneItemInCarousel(true);
		} else {
			setShowOneItemInCarousel(false);
		}
	}, [isSummaryAvailable]);

	return (
		<>
			<div>
				<div className="text-sm font-medium text-[#004FC4] dark:text-[#E5FFFF]">Video recording</div>

				<hr className="mt-2 border-t-[#E4E4EB] dark:border-[#303A47]" />

				<div className="mt-3">
					{recordings.length ? (
						<Carousel responsive={showOneItemInCarousel ? oneItemResponsive : responsive}>
							{recordings.map(r => {
								return (
									<div key={r.fileName} className="mx-auto h-full flex flex-col gap-y-3 w-full md:pr-2">
										<div className="w-full overflow-hidden rounded-[8px] h-full">
											<video controls autoPlay={false} className="video-container h-full w-full object-contain">
												<source src={r.fileName ?? ''} type="video/mp4" />
											</video>
										</div>
									</div>
								);
							})}
						</Carousel>
					) : (
						<div className="text-[#555770] dark:text-[#FFFEE5] text-sm font-light italic">No recordings available</div>
					)}
				</div>
			</div>
		</>
	);
};

export default VideoRecordingContainer;
